export default "__VITE_ASSET__Cggk7SYE__"